/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsMetadataRpc
 */

/**
 *  The Breeze agent ids to resolve display names for. The FE runs on app auth and cannot call the
 *  INTERNAL-only {@code BreezeEngineAdminService}, so it batches the agent ids shown in one view
 *  (approver pickers, activity feeds) into a single call here.
 */

/**
 *  The display name for one Breeze agent, echoing the requested id so callers can match results back
 *  regardless of order. {@code displayName} is empty when the agent is not found, not visible to the
 *  caller, or Breeze could not be reached — the FE falls back to the raw agent ID in that case.
 */

export const listApprovalSettingsAssetsRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsMetadataRpc',
  rpcName: 'listApprovalSettingsAssets',
  auth: 'app',
  fingerprint: 'e6dgMuePSY26HhNekjKGeIT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const resolveBreezeAgentNamesRpc = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsMetadataRpc',
  rpcName: 'resolveBreezeAgentNames',
  auth: 'app',
  fingerprint: '1DAwWBblEPVEiMxbS5fnN4T0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};